import { ModuleStructure } from 'src/app/models/module-structure';
import { RecordModel } from './../record-model';
import { Section } from '../../models/module-structure';
import { tap, switchMap, concatMap } from 'rxjs/operators';
import { LayoutService } from '../layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as g from '../../globals';
import { RecordPageComponent } from '../record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { FieldValueChangedArgs } from '../field-value-changed-args';
import { Subscription, concat, Observable } from 'rxjs';
import { Guid } from '@app/models/guid';
@Component({
  selector: 'app-shopping-list',
  templateUrl: './shopping-list.component.html',
  styleUrls: ['./shopping-list.component.less'],
})
export class ShoppingListComponent implements OnInit, OnDestroy {
  docType = 0;
  sectionId = 0;
  section: Section;
  queryId = 0;
  data: any[] = [];
  isLoading = false;
  showTable = true;
  recordId = 0;
  mode = '';
  identity: { area: number; customerCode: string } = {
    area: 1,
    customerCode: '',
  };
  tableLoading: boolean;
  subs: Subscription[] = [];
  moduleStructure: ModuleStructure;
  recordModel: RecordModel;

  customerIsActive = false;
  onHoldMsg = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {}
  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
    this.layoutService.containerTransparentBGEmitter.emit(false);
    this.layoutService.containerFooterLeftPaddingEmitter.emit(0);
  }

  ngOnInit(): void {
    this.layoutService.executeQuery(80035).subscribe((result: any) => {
      this.customerIsActive = result[0].Value === 'N';
    });
    this.layoutService.executeQuery(80036).subscribe((result: any) => {
      this.onHoldMsg = result[0].Value;
    });
    this.layoutService.containerTransparentBGEmitter.emit(true);
    this.getParams();
    console.log('shopping list -> ngoninit');
    this.onRecordModelChange();
  }

  getParams() {
    this.isLoading = true;
    this.route.params
      .pipe(
        tap((params) => {
          this.identity = {
            area: g.userIdentity.Area,
            customerCode: g.userIdentity.CardCode,
          };
          this.docType = params.docType;
          this.sectionId = params.sectionId;
          if (params.selectedId) {
            this.showTable = false;
            this.recordId = params.selectedId;
            this.mode = 'edit';
          } else if (params.mode) {
            this.mode = params.mode;
            this.showTable = false;
          } else {
            this.mode = '';
            this.showTable = true;
            this.recordModel = undefined;
            this.moduleStructure = undefined;
          }
        }),
        switchMap(() => this.getSectionData()),
        switchMap(() => this.getDrafts())
      )
      .subscribe();
  }

  getSectionData() {
    return this.layoutService.getSection(this.sectionId).pipe(
      tap((data: any) => {
        this.section = data;
        this.queryId = this.section.SQLStatementId;
      })
    );
  }
  getDrafts() {
    return this.layoutService.getDataFromQuery(this.queryId, []).pipe(
      tap((data: any) => {
        console.log(data);
        this.isLoading = false;
        this.tableLoading = false;
        this.data = [...[], ...data.table.rowsArray];
        if (this.data.length === 0 && this.customerIsActive) {
          this.createShoppingList();
        }
      })
    );
  }

  continueShopping(docEntry) {
    this.recordId = docEntry;
    // this.recordModel.FromDraft = true;
    this.router.navigate([{ selectedId: docEntry }], {
      relativeTo: this.route,
    });
  }

  createShoppingList() {
    this.mode = 'add';
    this.showTable = false;
    this.router.navigate(['.', { mode: 'add' }], { relativeTo: this.route });
  }
  linkedObjectSubmitted(event) {
    this.router.navigate(['.', {}], { relativeTo: this.route });
    console.log(event);
    this.showTable = true;
    this.getDrafts().subscribe();
  }
  backButtonClicked() {
    this.router.navigate(['.', {}], { relativeTo: this.route });
    this.showTable = true;
  }
  deleteShoppingList(docEntry) {
    this.tableLoading = true;
    this.layoutService
      .ExecuteMethodOfModule(20, 'Cancel', docEntry.toString())
      .pipe(switchMap(() => this.getDrafts()))
      .subscribe();
  }
  onRecordModelChange() {
    this.subs.push(
      this.layoutService.fieldValueChanged.subscribe(
        (data: FieldValueChangedArgs) => {
          setTimeout(() => {
            const propertyName = data.recordProperty.Name;
            const sectionName = data.sectionTagName;
            if (this.moduleStructure == null) {
              this.moduleStructure = JSON.parse(
                JSON.stringify(data.moduleStructure)
              );
            }

            if (
              (propertyName === 'CardCode' ||
                propertyName === 'ShipToCode' ||
                (propertyName === 'LineTotal' &&
                  sectionName === 'Document_Lines')) &&
              data.recordProperty.ValueAsObject != null
            ) {
              const documents = data.recordModel.Categories.find(
                (x) => x.Id === 'Documents'
              ).Lines;
              let shipToCode = documents[0].Properties.find(
                (x) => x.Name === 'ShipToCode'
              ).ValueAsObject as string;
              if (propertyName === 'ShipToCode') {
                shipToCode = data.recordProperty.ValueAsObject;
              }
              if (
                (propertyName === 'CardCode' ||
                  propertyName === 'ShipToCode' ||
                  (propertyName === 'LineTotal' &&
                    sectionName === 'Document_Lines')) &&
                data.recordProperty.ValueAsObject != null
              ) {
                if (propertyName === 'ShipToCode') {
                  shipToCode = data.recordProperty.ValueAsObject;
                  // LayoutService.setValue(
                  //   data.recordProperty, data.recordProperty.ValueAsObject, this.layoutService,
                  //   data.recordModel, data.line, data.sectionTagName, data.moduleStructure);
                }
                /*if (shipToCode.includes("'") && !shipToCode.includes("''")) {
                  shipToCode = shipToCode.replace(/'/g, "''");
                  data.recordModel.Categories.find(
                    (x) => x.Id === 'Documents'
                  ).Lines[0].Properties.find(
                    (x) => x.Name === 'ShipToCode'
                  ).ValueAsObject = shipToCode;
                }*/
                const recordModelAsText = JSON.stringify(data.recordModel);
                RecordModel.getShippingDetailsLastRequestId = Guid.newGuid();
                RecordModel.ExecuteCustomAction(
                  'GetShippingDetails_' + RecordModel.getShippingDetailsLastRequestId,
                  this.layoutService,
                  data.recordModel,
                  '',
                  this.moduleStructure,
                  this.drawerService,
                  this,
                  '',
                  this.router,
                  () => {}
                );
              }
            }
          }, 2000);
        }
      )
    );
  }
  // getRecordModel() {
  //   return this.layoutService.getModuleStructure(59)
  //     .pipe(
  //       tap((data: any) => {
  //         this.moduleStructure = data;
  //       }),
  //       switchMap(() => this.layoutService.getValuesOnEdit(this.moduleStructure, 59, this.recordId) as Observable<any>),
  //       tap(recordModel => {
  //         this.recordModel = recordModel;
  //       })
  //     );

  // }
}
